import React from "react";
import LaborHackLogo from "assets/logos/brand.svg";
import { Image } from "@chakra-ui/react";
import { GoArrowUpRight } from "react-icons/go";
import { useHistory } from "react-router-dom";
import artisansLaughing from "assets/artisans-laughing.png";
import artisanAndClient from "assets/artisan-and-client.png";
import artisanOnLadder from "assets/artisan-on-ladder.png";
import artisanObservingShipment from "assets/artisan-observing-shipment.jpeg";
import clsx from "clsx";

type UserTypeCardProps = {
  cta: string;
  text: string;
  image: string;
  link: string;
  flipImage?: boolean;
};

export const LandingPageV2 = () => {
  const navigate = useHistory().push;

  const UserTypeCard = ({
    cta,
    image,
    text,
    link,
    flipImage,
  }: UserTypeCardProps) => {
    return (
      <div
        className="relative group cursor-pointer hover:scale-[1.02] transition-all duration-300"
        onClick={() => navigate(link)}
      >
        <div className="w-full h-[420px] lg:h-[445px] bg-[#FBE2DE] overflow-hidden">
          {/* Image Area */}
          <div className="w-full h-[239px] flex items-center justify-center">
            <Image
              src={image}
              alt={text}
              objectFit="cover"
              className={clsx(
                "w-full h-full object-cover",
                flipImage && "scale-x-[-1]"
              )}
            />
          </div>

          {/* Text Content */}
          <div className="py-4 px-4">
            <div className="flex flex-col gap-1">
              <p className="text-[#464646] text-base lg:text-lg font-normal font-[Inter] leading-[1.333]">
                {cta.toUpperCase()}
              </p>
              <h3 className="text-[#2F1612] text-2xl lg:text-[32px] font-medium font-[AeonikPro] leading-[1.25]">
                {text}
              </h3>
            </div>
          </div>

          {/* Arrow Button */}
          <div className="pt-8 px-4">
            <div className="w-16 h-16 bg-[#FEFEFE] rounded-full flex items-center justify-center">
              <GoArrowUpRight className="text-[#2F1612] w-5 h-5 lg:w-6 lg:h-6" />
            </div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className="min-h-screen bg-[#FEFEFE] flex flex-col">
      {/* Main Content */}
      <div className="flex-1 flex flex-col items-center justify-center px-4 py-8 md:py-16">
        {/* Logo and Title Section */}
        <div className="text-center mb-8 md:mb-16">
          {/* LaborHack Logo */}
          <div className="mb-8">
            <div className="flex justify-center">
              <div className="w-72 h-10 flex items-center justify-center">
                {/* Logo placeholder - red colored letters */}
                <Image
                  src={LaborHackLogo}
                  alt="LaborHack"
                  height="40px"
                  width="280px"
                />
              </div>
            </div>
          </div>

          {/* Main Title */}
          <h1 className="text-[#2F1612] text-4xl md:text-6xl font-medium leading-tight">
            Find Talent. Get hired
          </h1>
        </div>

        {/* Service Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 w-full max-w-7xl">
          {/* Find Talents (Businesses) Card */}
          <UserTypeCard
            cta="Find Talent"
            text="Businesses"
            image={artisanObservingShipment}
            link="/businesses"
          />
          {/* Find Talent (Homeowners) Card */}
          <UserTypeCard
            cta="Find Talent"
            text="Homeowners"
            image={artisanAndClient}
            link="/homeowners"
          />

          {/* Get Jobs (Skilled Workers) Card */}
          <UserTypeCard
            cta="Get Jobs"
            text="Skilled workers"
            image={artisanOnLadder}
            link="/skilled-workers"
          />

          {/* Manage Talents (Community) Card */}
          <UserTypeCard
            cta="Manage Talent"
            text="Community"
            image={artisansLaughing}
            flipImage
            link="/community-manager"
          />
        </div>
      </div>

      {/* Footer */}
      <div className="py-8 text-center">
        <p className="text-[#0B1922] text-lg">
          {`${new Date().getFullYear()} © LaborHack. All Rights Reserved`}
        </p>
      </div>
    </div>
  );
};